<template>
    <div>
        <slot></slot>
    </div>
</template>
<script>
    import $ from 'jquery';
    import Slick from 'vue-slick';

    export default {
        extends: Slick,

        destroyed: function () {
            const $slick = $(this.$el);
            $slick.next('.slick-paging').empty().remove();
        },

        methods: {
            create: function () {
                const $slick = $(this.$el);

                $slick.on('afterChange', this.onAfterChange);
                $slick.on('afterChange', this.updateMobilePaging);
                $slick.on('beforeChange', this.onBeforeChange);
                $slick.on('breakpoint', this.onBreakpoint);
                $slick.on('destroy', this.onDestroy);
                $slick.on('edge', this.onEdge);
                $slick.on('init', this.onInit);
                $slick.on('init', this.setMobilePaging);
                $slick.on('reInit', this.onReInit);
                $slick.on('setPosition', this.onSetPosition);
                $slick.on('swipe', this.onSwipe);
                $slick.on('lazyLoaded', this.onLazyLoaded);
                $slick.on('lazyLoadError', this.onLazyLoadError);

                // remove any existing paging element
                $slick.next('.slick-paging').empty().remove();

                // ensure one is added
                $slick.after('<div class="slick-paging"><span class="paging-mobile d-md-none"></span></div>');

                // create carousel
                $slick.slick(this.options);

            },
            setMobilePaging: function (event, slick) {
                $(slick.$dots !== null && slick.$dots[0].parentNode).find('.paging-mobile').html(this.getMobilePaging(slick, 0));
            },
            updateMobilePaging: function(event, slick, currentSlide) {
                $(slick.$dots !== null && slick.$dots[0].parentNode).find('.paging-mobile').html(this.getMobilePaging(slick, currentSlide));
            },
            getMobilePaging: function(slick, currentSlide) {
                return (currentSlide / slick.options.slidesToShow + 1) + " / " + Math.ceil(slick.slideCount / slick.options.slidesToShow);
            }

        }
    }
</script>